import React from "react";
import store from "../store";
import PropTypes from "prop-types";
import classNames from "classnames";
import { withStyles } from "@material-ui/core/styles";
import ReactPlayer from "react-player";
import IntlTelInput from "react-intl-tel-input";
import "react-intl-tel-input/dist/main.css";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import MenuItem from "@material-ui/core/MenuItem";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";

import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import hideOnScroll from '../components/hideonscroll'
import MenuIcon from '@material-ui/icons/Menu';

import { NotificationManager } from 'react-notifications';
import CircularProgress from '@material-ui/core/CircularProgress';

import { Link } from "react-router-dom";

import ContactForm from '../components/ContactForm';
import Paper from '@material-ui/core/Paper';

import { Redirect } from 'react-router-dom';
import ButtonBase from '@material-ui/core/ButtonBase';
import PowerIcon from '@material-ui/icons/PowerSettingsNew';
import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";
import "firebase/storage";
import { FIREBASE } from "../config/firebase";
import Divider from '@material-ui/core/Divider';
import * as STATIC from '../config/static';

if (!firebase.apps.length) {
  firebase.initializeApp(FIREBASE);
}


const firestore = firebase.firestore();
//let IS_NAMING = window.location.hostname.toLowerCase()=='www1.namethegiraffe.com'?true:false;
//IS_NAMING = true;


var _this;

class InnerPage extends React.Component {

  constructor(props) {
    super(props);
    _this = this;
    this.state = {
      isEnd: false,
      isStarting:false,
      timer: props.timer ? props.timer : 60,

    };
  }
  updateDimensions() {
    //console.log(window.innerWidth);
    // _this.setState({
    //   innerWidth: window.innerWidth,
    //   innerHeight: window.innerHeight
    // });
  }
  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);

    this.setState({ loading: false });


    // this.setState({
    //   innerWidth: window.innerWidth,
    //   innerHeight: window.innerHeight
    // });
    //window.addEventListener("resize", this.updateDimensions);
    //this.loadBible();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
    if(_this.tick)
    {
      clearInterval(_this.tick);
    }
    if(_this.audio)
    _this.audio.pause();
  }

  updateWindowDimensions() {
    _this.setState({ wWidth: window.innerWidth, wHeight: window.innerHeight });
  }
  handleChange = name => event => {
    //event.preventDefault();
    _this.setState({ [name]: event.target.value });
  };


  logoutClick() {
    localStorage.removeItem('ACCOUNT');
    store.dispatch({ type: 'ACCOUNT', ACCOUNT: false });
    _this.setState({ ACCOUNT: null });
  }
  startTimer() {
    let { timer } = _this.state;
    if(_this.state.isStarting)
    return;
    _this.audio = new Audio("assets/sound/tick.mp3");
    _this.iaudio = new Audio("assets/sound/inner_bg.mp3");
    _this.setState({isStarting:true});
_this.iaudio.play();
    if (timer > 0) {
      _this.tick = setInterval(function() {
        // do your thing
        let second = _this.state.timer;
        if (second > 0) {
          second--;
        }
        if (second == 0) {
          clearInterval(_this.tick);
          _this.audio.pause();
          _this.iaudio.pause();
          _this.setState({ isEnd: true,counting:1 },()=>_this.startAnimation());
        }
        else {
          if(second == 5)
          {
            if(store.getState().SOUND==1)
            {
              _this.iaudio.pause();
              _this.audio.play();

            }
          }
          _this.setState({ timer: second });
        }

      }, 1000);
    }
  }
  startAnimation() {
    _this.audio = new Audio("assets/sound/bell.mp3");
    if(store.getState().SOUND==1)
    _this.audio.play();
    _this.tick = setInterval(function() {
      // do your thing
      let counting = _this.state.counting;
        counting++;


        _this.setState({ counting });


    }, 1000);
  }
  onEnd(){
    if(_this.props.onEnd)
    {
      _this.props.onEnd();
    }
  }


  getTimeText(time) {
    return STATIC.pad2(Math.floor(time / 60)) + ':' + STATIC.pad2(time % 60);
  }

  render() {
    const { classes,t } = this.props;
    const { wWidth, wHeight, isEnd,counting,isStarting } = this.state;
    let width = STATIC.DWIDTH;
    if (wWidth < STATIC.DWIDTH) {
      width = wWidth;
    }
    let sRate = 640 / 1005;
    if (width / wHeight > sRate) {
      width = wHeight * sRate;
    }
    let fLarge = width * 0.06;
    let fTitle = width * 0.04;
    let fNormal = width * 0.03;
    let fSmall = width * 0.02;
    let ACCOUNT = store.getState().ACCOUNT;
    if (!ACCOUNT) {

      return (<Redirect to='/login' />);
    }
    let LANG = store.getState().LANG;
    //console.log(ACCOUNT);
    return (
      <div className={classes.root} style={{backgroundImage:"url('"+store.getState().BG+"')"}}>
        <div className={classes.middle} >

          <div className={classes.square} style={{ width }} elevation={4}>
            <div style={{ padding: (STATIC.calSize(60, STATIC.DWIDTH, width) + 'px ' + STATIC.calSize(20, STATIC.DWIDTH, width) + 'px'), flexGrow: 1, position: 'relative' }}>
              <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(5, 63, 34, 0.7)', borderRadius: STATIC.calSize(10, STATIC.DWIDTH, width), zIndex: -1 }} />
              {isEnd ? (
                <div style={{ textAlign: 'center' }}>
                  <img
                    src={counting%2==0?"assets/web/ring_l.png":"assets/web/ring_r.png"}
                    style={{ width: STATIC.calSize(280, STATIC.DWIDTH, width), height: 'auto', marginTop: STATIC.calSize(20, STATIC.DWIDTH, width) }} />
                </div>

              ) : <div>
                  <img
                    src="assets/web/boost_inner.png"
                    style={{ height: 'auto', marginTop: STATIC.calSize(20, STATIC.DWIDTH, width), width: width * 0.8 }} />
                  <div style={{ textAlign: 'center', color: 'rgb(255, 242, 0)', margin: STATIC.calSize(5, STATIC.DWIDTH, width), fontSize: fLarge }}>
                  {t('common.boostyourinner')}
                  </div>

                  <div style={{ textAlign: 'center', margin: 0, color: 'white', fontFamily: 'UTMP', flexGrow: 1, fontSize: width * 0.23 }}>{this.getTimeText(this.state.timer)}</div>
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <ButtonBase
                      focusRipple
                      onClick={() => this.startTimer()}
                      style={{ width: width * 0.2, height: width * 0.2, borderRadius: width * 0.2 / 2, backgroundColor: 'rgb(141, 198, 63)', cursor: 'pointer', display: 'block' }}>
                      <div style={{ marginLeft: STATIC.calSize(10, STATIC.DWIDTH, width), border: '1px solid rgb(5, 63, 34)', color: 'rgb(5, 63, 34)', width: width * 0.2 - STATIC.calSize(10, STATIC.DWIDTH, width) * 2, height: width * 0.2 - STATIC.calSize(10, STATIC.DWIDTH, width) * 2, lineHeight: width * 0.2 - STATIC.calSize(10, STATIC.DWIDTH, width) * 2 + 'px', borderRadius: (width * 0.2 - STATIC.calSize(10, STATIC.DWIDTH, width) * 2) / 2,
                        fontSize: LANG=="en"?fLarge:fTitle }}>
                        {t('common.start')}</div>

                    </ButtonBase>
                  </div>
                </div>}
              <div style={{ display: 'flex', marginTop: STATIC.calSize(20, STATIC.DWIDTH, width), marginBottom: STATIC.calSize(-50, STATIC.DWIDTH, width) }}>
                <a href="/" style={{ width: '100%' }}>
                  <img
                    src="assets/web/logo_green.png"
                    style={{ width: STATIC.calSize(189, STATIC.DWIDTH, width), maxWidth: 296, height: 'auto' }} />
                </a>
                {isEnd ? <Button style={{ color: "#053f22", padding: (STATIC.calSize(6, STATIC.DWIDTH, width) + 'px ' + STATIC.calSize(16, STATIC.DWIDTH, width) + 'px'), minWidth: 0, backgroundColor: '#fdce07', fontWeight: 'bold', fontSize: fNormal, display: 'block', textTransform: "capitalize", fontWeight: 'normal', alignSelf: 'flex-start' }} size="large" variant="contained" onClick={() => this.onEnd()} >
                  {t('common.skip')}
              </Button> : false}
              </div>





            </div>
          </div>

        </div>


      </div>
    );
  }
}

InnerPage.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(STATIC.styles)(STATIC.translate('common')(InnerPage));
